import type { ReactNode } from 'react';
import type { ApplicationProgress } from '../../utils/application-progress';

export function ProgressTrack({ label, progress, action }: { label: string; progress: ApplicationProgress; action?: ReactNode }) {
  const bar = (
    <div
      className="relative h-8 overflow-hidden rounded-full bg-gray-200 dark:bg-white/10"
      role="progressbar"
      aria-valuenow={progress.percent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div
        className="h-full rounded-full bg-emerald-500 transition-[width] duration-500 ease-out"
        style={{ width: `${progress.percent}%` }}
      />
      <span
        className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-gray-900 dark:text-white"
        style={{ textShadow: '0 0 6px white, 0 0 2px white' }}
      >
        {progress.percent}%
      </span>
    </div>
  );
  if (!action) {
    return (
      <div className="w-full">
        <div className="flex items-center justify-between text-sm text-gray-700 dark:text-gray-300">
          <span>{label}</span>
          <span className="tabular-nums">{progress.done} out of {progress.total}</span>
        </div>
        <div className="mt-2">{bar}</div>
      </div>
    );
  }
  return (
    <div className="flex w-full flex-col gap-3 min-[640px]:flex-row min-[640px]:items-end min-[640px]:gap-4">
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-3 text-sm text-gray-700 dark:text-gray-300">
          <span>{label}</span>
          <span className="shrink-0 tabular-nums">{progress.done} out of {progress.total}</span>
        </div>
        <div className="mt-2">{bar}</div>
      </div>
      {action}
    </div>
  );
}
